export function getDeployment() {
    if (checkIfGroupDeployment()) {
        return localStorage.getItem('active-deployment') || '';
    } else {
        const environment = process.env.REACT_APP_ENVIRONMENT || 'canary';
        if (environment === 'production') {
            return window.location.hostname.split('.')[0];
        }

        return localStorage.getItem('test-deployment') || 'testing-v2';
    }
}

export function checkIfGroupDeployment() {
    /**
     * For local testing, you can set the value of REACT_APP_DEPLOYMENT_GROUP to true to test deployment group
     */
    if (process.env.REACT_APP_DEPLOYMENT_GROUP === 'true' || window.location.hostname === process.env.REACT_APP_DEPLOYMENT_GROUP_URL) {
        return true;
    }
    return false;
}
